import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'joined',
})
export class JoinedPipe implements PipeTransform {
  transform(value: unknown, user): unknown {
    if (Array.isArray(value) && value) {
      const newValue = value.filter(item => {
        const { participants, uid, status } = item;
        let partArr =
          typeof participants[0] === 'string'
            ? participants
            : participants.map(item => uid);
        return status === 'approved' && partArr.includes(user);
      });

      return newValue;
    } else return value;
  }
}
